/** Superficie en m² — umbral a partir del cual se muestra en hectáreas. */
export const SURFACE_HECTARE_THRESHOLD_M2 = 10_000;

const M2_PER_HECTARE = 10_000;

/** Parsea superficie en m² (API / catastro). NaN si no es numérico. */
export const parseSurfaceM2 = (value) => {
  if (value === '' || value === null || value === undefined) return NaN;
  if (typeof value === 'number') return Number.isFinite(value) ? value : NaN;

  const s = String(value).trim();
  if (!s) return NaN;

  if (s.includes(',')) {
    return parseFloat(s.replace(/\./g, '').replace(',', '.'));
  }

  const dotCount = (s.match(/\./g) || []).length;
  if (dotCount <= 1) {
    return parseFloat(s);
  }
  return parseFloat(s.replace(/\./g, ''));
};

const formatNumberAR = (num, decimals) => new Intl.NumberFormat('es-AR', {
  minimumFractionDigits: decimals,
  maximumFractionDigits: decimals,
}).format(num);

/**
 * Formatea superficie para UI: m² por debajo del umbral, ha a partir de 10.000 m².
 * @returns {{ value: string, unit: 'm²' | 'ha' } | null}
 */
export const formatSurfaceDisplay = (valueM2) => {
  const m2 = parseSurfaceM2(valueM2);
  if (Number.isNaN(m2)) return null;

  if (m2 >= SURFACE_HECTARE_THRESHOLD_M2) {
    const ha = m2 / M2_PER_HECTARE;
    const decimals = ha >= 1_000 ? 0 : ha >= 100 ? 1 : 2;
    return {
      value: formatNumberAR(ha, decimals),
      unit: 'ha',
    };
  }

  return {
    value: formatNumberAR(m2, 2),
    unit: 'm²',
  };
};

/** m² usable. 0, vacío y no numérico no cuentan: en catastro el 0 es “sin dato”. */
export const positiveSurfaceM2 = (value) => {
  const n = parseSurfaceM2(value);
  return Number.isNaN(n) || n <= 0 ? null : n;
};

/**
 * Superficie del lote para mostrar, ordenar y comparar en el front.
 * Primero la urbana (`urbansurface`), que es la de la ficha. Si es 0 o no está,
 * la total (`surface`). Cubre aliases de getmylots y `filter_attributes`.
 * @param {object|null|undefined} lot
 * @returns {number|null}
 */
export const resolveLotAreaM2 = (lot) => {
  if (!lot || typeof lot !== 'object') return null;
  const attrs = lot.filter_attributes && typeof lot.filter_attributes === 'object'
    ? lot.filter_attributes
    : null;
  const candidates = [
    lot.urbansurface,
    lot.lot_urbansurface,
    attrs?.urbansurface,
    attrs?.lot_urbansurface,
    lot.surface,
    lot.lot_surface,
    attrs?.surface,
    attrs?.lot_surface,
  ];
  for (let i = 0; i < candidates.length; i += 1) {
    const area = positiveSurfaceM2(candidates[i]);
    if (area != null) return area;
  }
  return null;
};
